import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Location } from 'history';
import { exceptionEventWeb } from 'common/appInterface';

const NotFountPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;

  useEffect(() => {
    exceptionEventWeb("404", "Page Not Found.", "2");
  }, []);

  return (
    <div>
      <span>Page Not Found<br /><br /></span>
      <span>pathname: {location.pathname}</span>
    </div>
  );
}

export default NotFountPage;